import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ShoppingCart, ChevronRight } from "lucide-react";

const LowStockAlert = ({ products = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white p-6 border-r-0 border-t-0 border border-gray-100 flex flex-col">
      <div className="flex items-center gap-2 mb-6">
        <AlertTriangle size={18} className="text-orange-500" />
        <h3 className="font-bold text-gray-900">Low Stock Alert</h3>
      </div>

      {products.length > 0 ? (
        <div className="space-y-4 flex-1">
          {products.map((item, idx) => (
            <div key={idx}>
              <div className="flex justify-between items-center mb-1">
                <span className="text-sm font-medium text-gray-900">
                  {item.title || "N/A"}
                </span>
                <span className="text-xs font-bold text-orange-600">
                  {item.quantity || 0} left
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-2 flex-1 flex flex-col items-center justify-center py-8">
          <div className="p-1 border border-slate-300 bg-[#F8F5F1] rounded-full overflow-hidden">
            <ShoppingCart size={22} className="text-[#BFAC93]" />
          </div>
          <h4 className="font-medium text-base text-[#0C0C0E] text-center">
            All stock levels are healthy
          </h4>
          <p className="text-sm text-slate-400 text-center">
            You'll see alerts here when items run low
          </p>
        </div>
      )}

      <button
        onClick={() => navigate("/product")}
        className="w-full text-center mt-6 text-sm font-semibold text-[#4A6741] flex items-center justify-center gap-1 active:scale-95 transition-transform duration-100"
      >
        View All Products <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default LowStockAlert;
